import { CSSProperties } from 'react';
import { withIcon } from './withIcon';

const MenuDotsSvg = ({ style }: { style?: CSSProperties }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M11.5607 4.93934C12.1464 5.52512 12.1464 6.47487 11.5607 7.06066C10.9749 7.64644 10.0251 7.64644 9.43934 7.06066C8.85355 6.47487 8.85355 5.52512 9.43934 4.93934C10.0251 4.35355 10.9749 4.35355 11.5607 4.93934Z"
        fill="currentColor"
      />
      <path
        d="M7.06065 4.93934C7.64644 5.52512 7.64644 6.47487 7.06065 7.06066C6.47487 7.64644 5.52512 7.64644 4.93934 7.06066C4.35355 6.47487 4.35355 5.52512 4.93934 4.93934C5.52512 4.35355 6.47487 4.35355 7.06065 4.93934Z"
        fill="currentColor"
      />
      <path
        d="M2.56066 4.93934C3.14644 5.52512 3.14644 6.47487 2.56066 7.06066C1.97487 7.64644 1.02512 7.64644 0.439338 7.06066C-0.146446 6.47487 -0.146446 5.52512 0.439338 4.93934C1.02512 4.35355 1.97487 4.35355 2.56066 4.93934Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const MenuDots = withIcon(MenuDotsSvg);
